<div
  class="bg-white rounded shadow-[10px_10px_40px_0px_rgba(255,145,80,0.10)] p-6 w-full h-full overflow-hidden"
>
  <ng-content></ng-content>
</div>
